import NewsCategoryPage from './NewsCategoryPage.jsx';
import NewsDetailPage from './NewsDetailPage.jsx';

export {
  NewsCategoryPage,
  NewsDetailPage
}


// WEBPACK FOOTER //
// ./pages/news/index.js